const VIEWER_LOADED_EVENT = 'VIEWER_LOADED_EVENT'

export const dispatchViewerIsLoaded = () => {
  const viewerIsLoaded = new Event(VIEWER_LOADED_EVENT)
  document.dispatchEvent(viewerIsLoaded)
}
